import { render, staticRenderFns } from "./RecipientsBackupYN.vue?vue&type=template&id=6dfbdd70"
import script from "./RecipientsBackupYN.vue?vue&type=script&lang=js"
export * from "./RecipientsBackupYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports